/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * How long an archived project's documents are kept before deletion. `null` means never. Spelled
 * out rather than derived from the choices below, so TSOA can describe it in the API spec.
 */
export enum TDocumentRetentionChoice {
    '_30' = 30,
    '_60' = 60,
    '_90' = 90,
    '_180' = 180,
    '_365' = 365,
}
